import { render, staticRenderFns } from "./BulkEditWizardModal.vue?vue&type=template&id=38171158&scoped=true"
import script from "./BulkEditWizardModal.vue?vue&type=script&lang=js"
export * from "./BulkEditWizardModal.vue?vue&type=script&lang=js"
import style0 from "./BulkEditWizardModal.vue?vue&type=style&index=0&id=38171158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38171158",
  null
  
)

export default component.exports